module.exports = __webpack_public_path__ + "static/media/zm.1c375d50.svg";